module.exports = __webpack_public_path__ + "static/img/__wine-tasting.9345eb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__wine-tasting.jpg
// module id = eOh0
// module chunks = 0